/**
 * Der Hinweis der Oberfläche auf `409 EINRICHTUNG_OFFEN` — Auftrag
 * `PF-assistent`, Task 11 des Plans Systemeinstellungen, Spec Abschnitt 6.2.
 *
 * **Eine eigene, importfreie Datei**, weil zwei Stellen denselben Satz
 * brauchen und keine die andere einziehen soll: `api/client.ts` setzt ihn an
 * die Stelle der Servermeldung (er ist die einzige Stelle, die jede Antwort
 * sieht), und `ui/elements.tsx` erkennt an ihm den Fehlerkasten, dem es einen
 * Verweis auf die Einrichtung anhängt. Ein Satz an zwei Orten, der nicht aus
 * einer Quelle käme, wäre eine Erkennung, die still aufhört zu greifen.
 */
export const EINRICHTUNG_OFFEN_HINWEIS =
  'Die Ersteinrichtung ist noch nicht abgeschlossen. Bis dahin lässt sich nur die Einrichtung selbst bearbeiten.';

/** Die Adresse des Assistenten — dieselbe wie `toPath({ name: 'einrichtung' })`. */
export const EINRICHTUNG_ADRESSE = '/einrichtung';
